import { createAction } from 'redux-actions';

export const clearReservationEdit = createAction(
  'CLEAR_RESERVATION_EDIT_ROUTE'
);
